import { getCurrencyCode } from '@pegasus/translation';
import { getRecommendationType } from '@pegasus/tracker';
import { tracker } from '../track';
import { formatPrice, getGA4Context } from '../../helpers';
export const trackRemoveFromCart = (payload, config) => {
    try {
        const { item, isCrossCampaign = false, isGetInspired = false, isTopPickArticle = false, } = payload;
        tracker.track('GA4-EEC-remove_from_cart', {
            event_name: 'remove_from_cart',
            remove_from_cart: {
                element: 'header',
                currency: getCurrencyCode(config.localeCode.replace('_', '-')),
                value: formatPrice(item.price),
                items: [
                    {
                        item_id: item.configSku,
                        item_name: item.name,
                        affiliation: null,
                        coupon: null,
                        discount: item.discountPercent,
                        index: null,
                        item_brand: item.brandCode,
                        item_list_id: null,
                        item_list_name: getGA4Context({
                            isCrossCampaign,
                            isGetInspired,
                            isTopPickArticle,
                        }),
                        item_variant: item.simpleSku,
                        location_id: null,
                        price: formatPrice(item.price),
                        quantity: 1,
                        size_availability: null,
                        item_availability: null,
                        is_sustainable: null,
                        feature_flag: null,
                        product_gender: (item.gender || []).toString() || null,
                        early_access_item: item.plusEarlyAccess ? 1 : 0,
                        recommended: getRecommendationType(item.reco),
                        article_size_recommendation: null,
                        product_delivery_dates: `${item.deliveryPromise.beginDate}_${item.deliveryPromise.endDate}`,
                        promotion_id: item.campaignIdentifier,
                    },
                ],
            },
        });
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('[@browsing/tracker] Tracking `remove_from_cart` failed.', e);
    }
};
